export default __webpack_public_path__ + "static/media/overflowMenu_solid.6f37ea36.svg";